import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { Button, CardMedia, Typography } from '@mui/material';
import mainImg from './images/main-2.jpg'
import axios from 'axios';

interface ISponsor {
  "nombre": string;
  "apellidos": string;
}

const Nuevo = () => {
    const [ sponsor, setSponsor ] = useState<ISponsor[]>([])
    const { search } = useLocation()

    const query = new URLSearchParams(search)
    const ref = parseInt(query.get("Ref") || "0")
 
    const getSponsor = async (id: number) => {
      if(!id) return
      const res = await axios.get('/api/referido/' + id)
      const da = await res.data
      setSponsor(da)
      ref && window.localStorage.setItem("Sponsor", ref.toString())
    }

    useEffect(() => {
      getSponsor(ref)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref])

    return (
      <Container sx={{ pt:12 }}>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={6} md={4}>
            <Card
              sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
            >
              <CardMedia
                  component="img"
                  height="300"
                  image={ mainImg }
                  alt="Finanservs"
              />
              <Link to={`/registro?Ref=${ref}`}>
                <Button variant="contained" fullWidth={true}>
                  Me quiero Registrar
                </Button>
              </Link>
            </Card>
          </Grid>
        </Grid>
        <Typography sx={{ pt:2 }} textAlign="center">
          { sponsor.length > 0 && `Referido por: ${sponsor[0].nombre} ${sponsor[0].apellidos}`}
        </Typography>
      </Container>
    )
}

export default Nuevo;